import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import isUndefined from 'lodash.isundefined';
import sortBy from 'lodash.sortby';
import { fetchMembersByCompany } from '@general/api/memberAPI';

const useMembersOfCompany = companyId => {
    const [formattedMembers, setFormattedMembers] = useState();
    const { data, ...rest } = useQuery(
        `members-${companyId}`,
        async () => {
            if (companyId === null) {
                return [];
            }

            const response = await fetchMembersByCompany(companyId);
            return response?.data?.data || null;
        },
        {
            enabled: !isUndefined(companyId),
            staleTime: Infinity,
        }
    );

    useEffect(() => {
        if (!data) {
            return;
        }

        setFormattedMembers(
            sortBy(
                data.map(({ id, name }) => {
                    const [lastName, firstName] = name.split(', ');
                    return { label: `${firstName} ${lastName}`, value: id };
                }),
                'label'
            )
        );
    }, [data]);

    return { coworkers: formattedMembers, ...rest };
};

export default useMembersOfCompany;
